<template>
  <v-container>
    <div id="headersEntregaLeitePorLinha">
      <div
        v-if="loading"
        :style="styleObject"
        class="text-center"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <div v-else>
        <div
          id="idTable"
          style="overflow-x: auto; max-width: 100%;"
        >
          <table
            style="width: 100%; color: black; border-collapse: collapse;"
            class="elevation-1"
          >
            <thead>
              <tr>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Linha de leite
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Quantidade de leite(Litros)
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Preço médio
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in melhoresLinhas"
                :key="item.id"
                style="cursor: pointer;"
                @click="redirectToDetalheLinha(item)"
              >
                <td
                  id="dadoMovimentacao"
                  style="text-align: left;"
                >
                  {{ item.nome_linha }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.qtdleite }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.precomedio }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          v-if="mostrarTotalizador"
          class="totalizador"
        >
          <span>
            <strong>
              Total de leite:
              {{ formateNum(totalLeite) }}
            </strong>
          </span>
        </div>
      </div>
    </div>
  </v-container>
</template>

    <script>
  import EntregaLeite from '../../../../services/entregaleite'
  import eventEmit from '../core/EventoEmit'

  export default {
    name: 'LinhasExibicaoEntregas',
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      headersEntregaLeitePorLinha: [
        { text: 'Linha de leite', value: 'nome_linha', class: 'black--text title' },
        { text: 'Quantidade de leite(Litros)', value: 'qtdleite', align: 'right', class: 'black--text title' },
        { text: 'Preço médio', value: 'precomedio', align: 'right', class: 'black--text title' },
      ],
      melhoresLinhas: [],
      linhaSelect: [],
      produtorSelect: [],
      totalLeite: 0,
    }),

    computed: {
      mostrarTotalizador () {
        return this.melhoresLinhas.length > 0
      },
      alturaTabela () {
        return this.melhoresLinhas.length < 7
          ? (this.melhoresLinhas.length === 0
            ? '96px'
            : `${this.melhoresLinhas.length * 48 + 48}px`)
          : '350px'
      },
    },

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)
    },

    mounted () {
      localStorage.removeItem('linhaleite')
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, produtores, linhasleite) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select
        this.produtorSelect = produtores
        this.linhaSelect = linhasleite

        this.showMelhoresEntregasPorLinha()
      },

      async showMelhoresEntregasPorLinha () {
        this.loading = true
        this.melhoresLinhas = []

        await EntregaLeite.showMelhoresEntregasPorLinha(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato, this.produtorSelect, this.linhaSelect).then(resposta => {
          if (resposta.data.status) {
            this.melhoresLinhas = resposta.data.dadosMelhoresLinhas.map((item) => {
              return {
                nome_linha: item.nome_linha,
                linhaId: item.linhaId,
                qtdleite: this.formateNum(item.qtdleite),
                quantidade: item.quantidade,
                precomedio: this.formatMoeda(item.media),
              }
            })

            this.totalLeite = this.formateNum(resposta.data.totalLeite)

            this.melhoresLinhas.add(this.totalLeite)
          } else if (resposta.data.msg === 'Não há dados no período selecionado') {
            this.melhoresLinhas = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false
        })
      },

      redirectToDetalheLinha (item) {
        localStorage.setItem('linhaleite', JSON.stringify(item))
        this.$router.push({ name: 'detalhe-melhores-entregasleite-linhasleite', params: { item } })
      },

      formateNum (num) {
        return num.toLocaleString('pt-BR', { maximumFractionDigits: 0 })
      },

      formatMoeda (num) {
        return 'R$' + num.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 4 })
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  .table-row {
    margin-top: 1px;
  }
  .total-label {
    text-align: left;
  }
  .total-value {
    text-align: right;
  }

  .totalizador td {
    font-weight: bold;
  }

  #textotabela {
    font-size: 0.75rem !important
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  .totalizador {
    display: table;
    width: 100%;
    table-layout: fixed;
    color: black;
    border-collapse: collapse;
    border-top: 1px solid #ccc;
    font-family: inherit;
  }

  .totalizador span {
    display: table-cell;
    padding: 8px;
    vertical-align: middle;
    border-bottom: 1px solid #ddd;
    font-weight: normal;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #headersEntregaLeitePorLinha {
      width: 100% !important;
    }

    #idTable {
      max-height: 500px;
      max-width: 395px !important;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #headersEntregaLeitePorLinha {
      width: 100% !important;
    }
  }

  @media ( min-device-width : 380px)
  and (max-device-width : 600px) {
    .data-value {
      /* padding-right: 14rem; */
      text-align: right;
    }
  }

  @media (min-device-width : 1380px) {
    .data-value {
      padding-right: 58rem;
      text-align: right;
    }
  }

  @media ( min-device-width : 601px)
  and (max-device-width : 1379px) {
    .data-value {
      padding-right: 0rem;
      text-align: right;
    }
  }
</style>
